import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface IErrorDialogData {
  title: string;
  subtitle: string;
  icon: string;
  helpCard: boolean;
  buttonDisabled: boolean;
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IErrorDialogData,
    public dialogRef: MatDialogRef<any>
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
